/* eslint-disable no-unused-vars */
import { Button, Grid } from "@mui/material";
import { green, grey, orange, purple } from "@mui/material/colors";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { makeStyles, withStyles } from "@mui/styles";

import BackspaceIcon from "@mui/icons-material/Backspace";
import PText from "../../components/pos/PText";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
const useStyles = makeStyles({});

const rPosTheme = createTheme({
  status: {
    danger: orange[500],
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: "1rem",
          fontWeight: "bold",
          padding: 1,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: 6,
        },
      },
    },
  },
});

const posTheme = createTheme({
  status: {
    danger: orange[500],
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: "1.9rem",
          fontWeight: "bold",
          padding: 1,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: 10,
        },
      },
    },
  },
});

const DigitButton = withStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100%",
    fontSize: "0.9rem",
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: purple[500],
    "&:hover": {
      backgroundColor: purple[700],
    },
  },
}))(Button);
const ActionButton = withStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100%",
    fontSize: "0.75rem",
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: orange[500],
    "&:hover": {
      backgroundColor: orange[700],
    },
  },
}))(Button);

const ActionButtonDisabled = withStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100%",
    fontSize: "0.75rem",
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: grey[500],
    "&:hover": {
      backgroundColor: grey[700],
    },
  },
}))(Button);

const EnterButton = withStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "100%",
    fontSize: "0.8rem",
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
}))(Button);
let prevKeyTime = 0;
export default function DigitPanel(props) {
  const { t } = useTranslation();
  const translate = t;
  const classes = useStyles();
  const [digits, setDigits] = useState("");
  const [enableDiscButton, setEnableDiscButton] = useState(true);

  useEffect(() => {}, [props.data]);

  props.biRef.digitPanel = {
    parentEvent: parentEvent,
  };

  function parentEvent(event, value1, value2, value3) {
    if (event === "onKeyPressed") {
      if (value1 === "Backspace") {
        if (digits.length > 0) {
          setDigits(digits.slice(0, -1));
        }
      } else if (value1 === "Enter")
        props.handleDigitPanelEvent("onBarcodeScanned", digits);
      else {
        onKeyPressed(value1);
      }
    } else if (event === "getDigits") {
      return digits;
    }
    if (event === "setDigits") {
      setDigits(value1);
    }
  }

  function onKeyPressed(value) {
    var d = new Date();
    var n = d.getTime();
    if (prevKeyTime + 10000 > n) {
      if (value === "." && digits.includes(".")) setDigits(digits);
      else {
        setDigits(digits + value);
      }
    } else {
      setDigits(value);
    }
    prevKeyTime = n;
  }

  function onQtyPressed() {
    //TODO parse digit and validate
    props.handleDigitPanelEvent("updateQty", digits);
    setDigits("");
  }

  function onPricePressed() {
    //TODO parse digit and validate
    props.handleDigitPanelEvent("updatePrice", digits);
    setDigits("");
  }

  function onDiscountPerPressed() {
    //TODO parse digit and validate
    props.handleDigitPanelEvent("updateDiscountPer", digits);
    setDigits("");
  }

  function onDiscountAmountPressed() {
    //TODO parse digit and validate
    props.handleDigitPanelEvent("updateDiscountAmount", digits);
    setDigits("");
  }

  function txtKeyPressed(e) {
    if (e.key === "Enter") {
      if (digits && digits.length > 0) {
        props.handleDigitPanelEvent("onBarcodeScanned", digits);
        setDigits("");
      }
      e.preventDefault();
      e.stopPropagation();
    } /*else if (Number(e.key) >= 0 || (e.key === "." && !digits.includes("."))) {
      setDigits(digits + e.key);
    } else if (e.key == "Backspace") setDigits(digits.slice(0, -1));*/
  }

  return (
    <ThemeProvider
      theme={props.context.appType === "R_POS" ? rPosTheme : posTheme}
    >
      <Grid
        container
        style={{
          height: props.context.appType === "R_POS" ? "210px" : "350px",
        }}
      >
        <Grid item xs={12}>
          <Grid container style={{ height: "100%" }}>
            <Grid item xs={9} style={{ paddingTop: 5 }}>
              <PText
                value={digits}
                error={""}
                onKeyDown={txtKeyPressed}
                onChange={(e) => setDigits(e.target.value)}
              ></PText>
            </Grid>
            <Grid item xs={3} style={{ paddingTop: 5 }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => setDigits(digits.slice(0, -1))}
                aria-label="delete"
                style={{
                  color: "white",
                  width: props.context.appType === "R_POS" ? "40px" : 75,
                  height: props.context.appType === "R_POS" ? 40 : 55,
                  marginLeft: 5,
                }}
              >
                <BackspaceIcon style={{ padding: 0, fontSize: "22px" }} />
              </Button>
            </Grid>
            <Grid item xs={3} style={{ padding: 2 }}>
              <DigitButton
                onClick={() => {
                  onKeyPressed("1");
                }}
              >
                1
              </DigitButton>
            </Grid>
            <Grid item xs={3} style={{ padding: 2 }}>
              <DigitButton
                onClick={() => {
                  onKeyPressed("2");
                }}
              >
                2
              </DigitButton>
            </Grid>
            <Grid item xs={3} style={{ padding: 2 }}>
              <DigitButton
                onClick={() => {
                  onKeyPressed("3");
                }}
              >
                3
              </DigitButton>
            </Grid>
            <Grid item xs={3} style={{ padding: 2, paddingRight: 5 }}>
              <ActionButton
                onClick={() => {
                  onQtyPressed();
                }}
                disabled={props.privileges.qty_buttun_allowed ? false : true}
                style={{
                  padding: "0px",
                }}
              >
                <div
                  style={{
                    width: "100%",
                  }}
                >
                  <Grid container>
                    <Grid item xs={12}>
                      {translate("QTY")}
                    </Grid>
                    {props.saleSetting &&
                      props.saleSetting.showKeyboardShortcuts && (
                        <Grid item xs={12} style={{ fontSize: "0.60rem" }}>
                          {translate("Ctrl+Q")}
                        </Grid>
                      )}
                  </Grid>
                </div>
              </ActionButton>
            </Grid>
            <Grid item xs={3} style={{ padding: 2 }}>
              <DigitButton
                onClick={() => {
                  onKeyPressed("4");
                }}
              >
                4
              </DigitButton>
            </Grid>
            <Grid item xs={3} style={{ padding: 2 }}>
              <DigitButton
                onClick={() => {
                  onKeyPressed("5");
                }}
              >
                5
              </DigitButton>
            </Grid>
            <Grid item xs={3} style={{ padding: 2 }}>
              <DigitButton
                onClick={() => {
                  onKeyPressed("6");
                }}
              >
                6
              </DigitButton>
            </Grid>
            <Grid item xs={3} style={{ padding: 2, paddingRight: 5 }}>
              <ActionButton
                onClick={() => {
                  onPricePressed();
                }}
                disabled={props.privileges.price_buttun_allowed ? false : true}
                style={{
                  padding: "0px",
                }}
              >
                <div
                  style={{
                    width: "100%",
                  }}
                >
                  <Grid container>
                    <Grid item xs={12}>
                      {translate("PRICE")}
                    </Grid>
                    {props.saleSetting &&
                      props.saleSetting.showKeyboardShortcuts && (
                        <Grid item xs={12} style={{ fontSize: "0.60rem" }}>
                          {translate("Ctrl+P")}
                        </Grid>
                      )}
                  </Grid>
                </div>
              </ActionButton>
            </Grid>
            <Grid item xs={3} style={{ padding: 2 }}>
              <DigitButton
                onClick={() => {
                  onKeyPressed("7");
                }}
              >
                7
              </DigitButton>
            </Grid>
            <Grid item xs={3} style={{ padding: 2 }}>
              <DigitButton
                onClick={() => {
                  onKeyPressed("8");
                }}
              >
                8
              </DigitButton>
            </Grid>
            <Grid item xs={3} style={{ padding: 2 }}>
              <DigitButton
                onClick={() => {
                  onKeyPressed("9");
                }}
              >
                9
              </DigitButton>
            </Grid>
            <Grid item xs={3} style={{ padding: 2, paddingRight: 5 }}>
              {enableDiscButton && (
                <ActionButton
                  onClick={() => {
                    onDiscountPerPressed();
                  }}
                  disabled={
                    props.privileges.disc_percent_buttun_allowed ? false : true
                  }
                  style={{
                    padding: "0px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                    }}
                  >
                    <Grid container>
                      <Grid item xs={12}>
                        {translate("DISC%")}
                      </Grid>
                      {props.saleSetting &&
                        props.saleSetting.showKeyboardShortcuts && (
                          <Grid item xs={12} style={{ fontSize: "0.60rem" }}>
                            {translate("Ctrl+%")}
                          </Grid>
                        )}
                    </Grid>
                  </div>
                </ActionButton>
              )}
              {!enableDiscButton && (
                <ActionButtonDisabled
                  disabled={true}
                  style={{
                    padding: "0px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                    }}
                  >
                    <Grid container>
                      <Grid item xs={12}>
                        {translate("DISC%")}
                      </Grid>
                      {props.saleSetting &&
                        props.saleSetting.showKeyboardShortcuts && (
                          <Grid item xs={12} style={{ fontSize: "0.60rem" }}>
                            {translate("Ctrl+%")}
                          </Grid>
                        )}
                    </Grid>
                  </div>
                </ActionButtonDisabled>
              )}
            </Grid>
            <Grid item xs={3} style={{ padding: 2 }}>
              <DigitButton
                onClick={() => {
                  onKeyPressed(".");
                }}
              >
                .
              </DigitButton>
            </Grid>
            <Grid item xs={3} style={{ padding: 2 }}>
              <DigitButton
                onClick={() => {
                  onKeyPressed("0");
                }}
              >
                0
              </DigitButton>
            </Grid>
            <Grid item xs={3} style={{ padding: 2 }}>
              <EnterButton
                onClick={() => {
                  props.handleDigitPanelEvent("onBarcodeScanned", digits);
                  setDigits("");
                }}
              >
                {translate("Enter")}
              </EnterButton>
            </Grid>
            <Grid item xs={3} style={{ padding: 2, paddingRight: 5 }}>
              {enableDiscButton && (
                <ActionButton
                  onClick={() => {
                    onDiscountAmountPressed();
                  }}
                  disabled={
                    props.privileges.disc_dollar_buttun_allowed ? false : true
                  }
                  style={{
                    padding: "0px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                    }}
                  >
                    <Grid container>
                      <Grid item xs={12}>
                        {translate("DISC$")}
                      </Grid>
                      {props.saleSetting &&
                        props.saleSetting.showKeyboardShortcuts && (
                          <Grid item xs={12} style={{ fontSize: "0.60rem" }}>
                            {translate("Ctrl+$")}
                          </Grid>
                        )}
                    </Grid>
                  </div>
                </ActionButton>
              )}
              {!enableDiscButton && (
                <ActionButtonDisabled
                  disabled={true}
                  style={{
                    padding: "0px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                    }}
                  >
                    <Grid container>
                      <Grid item xs={12}>
                        {translate("DISC$")}
                      </Grid>
                      {props.saleSetting &&
                        props.saleSetting.showKeyboardShortcuts && (
                          <Grid item xs={12} style={{ fontSize: "0.60rem" }}>
                            {translate("Ctrl+$")}
                          </Grid>
                        )}
                    </Grid>
                  </div>
                </ActionButtonDisabled>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
